import {NestedTreeControl} from '@angular/cdk/tree';
import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatTree, MatTreeNestedDataSource} from '@angular/material/tree';
import {Entity, ProjectGroup, Type} from 'app/pages/product/product.model';
import {BehaviorSubject, of} from 'rxjs';
import {ProductService} from '../../pages/product/product.service';
import {ProjectTreeNode} from './project-tree.model';
import {ProjectTreeService} from './project-tree.service';
import {EntityInfoComponent} from '../entity-info/entity-info.component';
import {Project} from '../../interfaces/interfaces';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {NewNodeComponent} from './new-node/new-node.component';
import {FormGroup} from '@angular/forms';
import {TreeDataSource} from './tree-datasource';

@Component({
    selector: 'project-tree',
    templateUrl: './project-tree.component.html',
    styleUrls: ['./project-tree.component.scss'],
    encapsulation : ViewEncapsulation.None
})
export class ProjectTreeComponent implements OnInit {

    // taskTypes: Type[];
    // phaseTypes: Type[];

    @Input()
    project: Project;

    entity: ProjectGroup;
    phasesTree: ProjectTreeNode[];

    @ViewChild('info')
    entityInfoComponent: EntityInfoComponent;


    // this.tree.renderNodeChanges()

    nestedTreeControl: NestedTreeControl<ProjectTreeNode>;
    nestedDataSource: MatTreeNestedDataSource<ProjectTreeNode>;
    dataChange: BehaviorSubject<ProjectTreeNode[]> = new BehaviorSubject<ProjectTreeNode[]>([]);
    activeNode: any;
    private dialogRef: MatDialogRef<any>;
    public dataSource: TreeDataSource;

    constructor(private projectTreeService: ProjectTreeService,
                private _matDialog: MatDialog) {
        this.nestedTreeControl = new NestedTreeControl<ProjectTreeNode>(node => node.children);
    }


    private sort(): void{

    }

    ngOnInit(): void {
        this.projectTreeService.getChildren(this.project.id).subscribe(
            resp => {
                if (resp){
                    this.phasesTree = resp.sort((a, b) => a.name > b.name ? 1 : -1);
                    // this.dataChange.next(resp);
                    this.dataSource = new TreeDataSource(this.nestedTreeControl, this.phasesTree);
                }

            }
        );
        this.projectTreeService.getGeneralTaskTypes().subscribe(
            resp => this.projectTreeService.taskTypes = resp
        );
        this.projectTreeService.getPhaseTypes().subscribe(
            resp => this.projectTreeService.phaseTypes = resp
        );
    }

    // private _getChildren = (node: ProjectTreeNode) => {
    //     if (node._children) {
    //         return of(node._children);
    //     }
    //     return this.productService.getChildren(node.id);
    // }



    // hasNestedChild = (_: number, nodeData: Entity) => {return !(nodeData.type); };
    hasNestedChild = (_: number, node: ProjectTreeNode) => !!node.children && node.children.length > 0;

    logNode(node: ProjectTreeNode): void {
        this.activeNode = node;
        this.projectTreeService.getProjectGroup(node.id).subscribe(
            resp => {
                this.entity = new ProjectGroup(resp);
                this.entityInfoComponent.selectEntity(this.entity);
            }
        );
        console.log(node);
    }

    moveUp(node: ProjectTreeNode): void{
        if (this.isTask(node)){

        }
    }

    moveDown(node: ProjectTreeNode): void{

    }

    isTask(node: ProjectTreeNode): boolean{
        return node && (node.type.type === 'GeneralTask' ||
            node.type.type === 'Subcontract' ||
            node.type.type === 'Request' ||
            node.type.type === 'Incident');
    }



    /** Add an item to to-do list */
    insertItem(type: string, parent: ProjectTreeNode, name: string): void {

        this.dialogRef = this._matDialog.open(NewNodeComponent, {
            panelClass: 'new-node-dialog',
            data      : {
                parent: parent,
                type: type
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }
                const newNode: ProjectTreeNode  = response.getRawValue();
                let children: ProjectTreeNode[];
                if (parent) {
                    newNode.parentId = parent.id;
                    newNode.type.type = 'GeneralTask';
                    children = parent.children;
                } else {
                    newNode.parentId = this.project.id;
                    newNode.type.type = 'Phase';
                    children = this.phasesTree;
                }

                newNode.index = 0;

                this.projectTreeService.createTreeNode(newNode).subscribe(
                    resp => {
                        const node = new ProjectTreeNode(resp);
                        if (parent) {
                            this.dataSource.add(node, parent);
                        } else {
                            children.push(node);
                            this.dataSource._data.next(this.phasesTree);
                        }
                    }
                );

            });
    }

}
